import React, {useEffect} from "react";
import {observer} from "mobx-react-lite";
import {useSitStores} from "../../../../stores";
import {AuditLogTable} from "../../../components/AuditLogTable";

export const InitiativeAuditLogForm: React.FC = observer(() => {
    const {initiativeInstanceStore, auditLogStore} = useSitStores();
    const result = auditLogStore.initiativeAuditLogRM.result;

    useEffect(() => {
        if (!initiativeInstanceStore.creating && (initiativeInstanceStore.instance.id ?? 0) !== 0) {
            auditLogStore.initiativeAuditLogRM.request({id: initiativeInstanceStore.instance.id!});
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initiativeInstanceStore.instance.id]);

    return <AuditLogTable entries={result}/>;
});
